export default {
      id: "oc-icon_add-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_add",
      toString: function () {
        return this.url;
      }
    }